import React from 'react';

// Importa os teus ícones com o caminho exato agora que sabemos onde estão
import bronzeAdepto from './assets/niveis/bronze_adepto.png';
import prataAdepto from './assets/niveis/prata_adepto.png';
import ouroAdepto from './assets/niveis/ouro_adepto.png';
import diamanteAdepto from './assets/niveis/diamante_adepto.png';
import campeaoAdepto from './assets/niveis/campeao_adepto.png';

// Novas importações das braçadeiras (Jogadores / Streamers)
import bronzeJogador from './assets/niveis/bronze_jogador.png';
import prataJogador from './assets/niveis/prata_jogador.png';
import ouroJogador from './assets/niveis/ouro_jogador.png';
import diamanteJogador from './assets/niveis/diamante_jogador.png';
import campeaoJogador from './assets/niveis/campeao_jogador.png';

export default function ConquistasFuturas({ nivelAtual, tipo = 'jogador' }) {
  // Configuração dos 5 escalões mudando a imagem consoante o tipo recebido
  const escaloes = [
    { nome: 'Bronze', nivel: 1, img: tipo === 'jogador' ? bronzeJogador : bronzeAdepto },
    { nome: 'Prata', nivel: 11, img: tipo === 'jogador' ? prataJogador : prataAdepto },
    { nome: 'Ouro', nivel: 21, img: tipo === 'jogador' ? ouroJogador : ouroAdepto },
    { nome: 'Diamante', nivel: 36, img: tipo === 'jogador' ? diamanteJogador : diamanteAdepto },
    { nome: 'Lenda', nivel: 51, img: tipo === 'jogador' ? campeaoJogador : campeaoAdepto },
  ];

  return (
    <div style={styles.container}>
      <p style={styles.textoTitulo}>Próximos Escalões a Conquistar:</p>
      <div style={styles.linhaCrachas}>
        {escaloes.map((escalao, index) => {
          // Verifica se o nível atual do utilizador já atingiu este escalão
          const jaConquistou = nivelAtual >= escalao.nivel;
          
          return (
            <div key={index} style={styles.itemCracha}>
              <img 
                src={escalao.img} 
                alt={escalao.nome} 
                style={{
                  ...styles.imagem,
                  opacity: jaConquistou ? 1 : 0.25, // Fica bem apagado se estiver bloqueado
                  filter: jaConquistou ? 'none' : 'grayscale(100%) brightness(0.5)' // Preto e branco para os bloqueados
                }} 
              />
              <span style={{
                ...styles.legenda,
                color: jaConquistou ? '#ff007f' : '#555' // Rosa se já tem, cinzento se bloqueado
              }}>
                Lv.{escalao.nivel}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
    textAlign: 'center',
    margin: '15px 0',
    fontFamily: 'sans-serif',
  },
  textoTitulo: {
    color: '#888',
    fontSize: '0.75rem',
    marginBottom: '8px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  },
  linhaCrachas: {
    display: 'flex',
    justifyContent: 'center',
    gap: '12px',
  },
  itemCracha: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  imagem: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    transition: 'all 0.3s ease',
  },
  legenda: {
    fontSize: '0.7rem',
    marginTop: '4px',
    fontWeight: 'bold',
  }
};
